import { render } from "./ZaikoMoveDetailPage.vue?vue&type=template&id=70177c98"
import script from "./ZaikoMoveDetailPage.vue?vue&type=script&lang=js"
export * from "./ZaikoMoveDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\eguchi\\Desktop\\git\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__